<div class="p-4">
  <h1 class="leading-8 mb-1">Information</h1>
  <p class="leading-5">Manage your general account settings.</p>
  <mat-divider class="!mt-4 !mb-8"></mat-divider>

  <div class="flex flex-col items-center" *ngIf="profile">
    <div class="w-[650px] p-5 bg-white flex flex-col gap-4 mat-elevation-z1" [formGroup]="profileFG">
      <div class="flex gap-4">
        <mat-form-field class="flex-auto">
          <mat-label>First name</mat-label>
          <input matInput formControlName="givenName" required />
          <mat-error>Your first name is empty</mat-error>
        </mat-form-field>
        <mat-form-field class="flex-auto">
          <mat-label>Last name</mat-label>
          <input matInput formControlName="familyName" required />
          <mat-error>Your last name is empty</mat-error>
        </mat-form-field>
      </div>

      <mat-form-field>
        <mat-label>Choose how your name will appear on your profile</mat-label>
        <mat-select formControlName="inverse">
          <mat-option *ngFor="let item of displayNameOptions" [value]="item.key">
            {{ item.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Timezone</mat-label>
        <mat-select formControlName="timezoneUuid">
          <mat-option *ngFor="let item of timezones$ | async" [value]="item.uuid">{{ item.displayText }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="no-validator">
        <mat-label>About</mat-label>
        <textarea matInput formControlName="about" rows="5"></textarea>
        <mat-error>Maximum 200 characters</mat-error>
      </mat-form-field>
    </div>

    <div class="w-[650px] flex justify-end items-center gap-2 mt-4">
      <button mat-stroked-button [disabled]="profileFG.invalid || isDisable" (click)="discardChange()">
        Discard changes
      </button>
      <button
        mat-flat-button
        [loading]="progressing"
        [disabled]="profileFG.invalid || isDisable"
        color="primary"
        (click)="updatePersonal()"
      >
        Save
      </button>
    </div>
  </div>
</div>
